export const LABEL_DAY_USE = 'Day Use'
export const LABEL_TARIF_SAISONAL = 'Tarif saisonal'
export const INFO_VOAYAGEUR = "Les enfants de 5 ans et plus sont comptés comme voyageurs."